/**
 * Sawyer 02 kennel-stopgap (A1-stopgap, A3-stopgap) — where the "Meds & feeding" buttons go,
 * and who sees them. Sawyer (memo1 [04:01]): "under day list, have another
 * button there for medication and feeding".
 *
 * THE SEAM. Both entry points — the Day list header (`CalendarDay`, testid
 * `calendar-day-meds-feeding`) and the Dashboard header (testid
 * `dashboard-meds-feeding`) — call these two functions and nothing else.
 *
 * Today the target is the kennel roster at `/kennel` in its desk framing.
 * Lane 08 (meds-feeding) builds the real AM / Noon / PM report at
 * `/meds-feeding?date=&service=`, gated by `ROUTE_ACCESS_RULES['/meds-feeding']`
 * (`['pets:read']`, which also admits walker and groomer). To repoint, lane 08
 * edits ONLY `medsFeedingHref` and `canOpenMedsFeeding` below: no second
 * CalendarDay link, and the Dashboard button follows automatically. Once
 * repointed, managers reach `/kennel` only by its URL, which is intended.
 */
import { rolesCanAccessPath } from './route-permissions.js';

export const MEDS_FEEDING_LABEL = 'Meds & feeding';

/** Which page the viewer left from; the target's back link returns there. */
export type MedsFeedingOrigin = 'day-list' | 'dashboard';

/** The Day list filters that ride along so "back" lands on the same view. */
export type MedsFeedingCarry = {
  readonly service?: string | null;
  readonly view?: string | null;
};

/** Where the "Meds & feeding" buttons go for a date. */
export function medsFeedingHref(
  date: string,
  from: MedsFeedingOrigin,
  carry: MedsFeedingCarry = {},
): string {
  const params = new URLSearchParams({ date, from });
  if (carry.service) params.set('service', carry.service);
  if (carry.view && carry.view !== 'all') params.set('view', carry.view);
  return `/kennel?${params.toString()}`;
}

/** Can these effective roles open the target? The same gate the route uses. */
export function canOpenMedsFeeding(
  roles: ReadonlyArray<string> | null | undefined,
): boolean {
  return rolesCanAccessPath(roles, '/kennel');
}
